import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.temperatureAmounts.loading;
export const temperatureAmountsErrorMessage = (state: RootState) =>
  state.temperatureAmounts.error;
export const temperatureAmountsDataResponse = (state: RootState) =>
  state.temperatureAmounts.temperatureAmountsResponse;
